import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './ToggleButton.css'

@CSSModules(styles)

export default class ToggleButton extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func
  }

  static defaultProps = {
    checked: false
  }  

  _onChange () {
    this.props.onChange(!this.props.checked)
  }

  render () {
    return (
      <div styleName="toggle-button">
        <input
          checked={this.props.checked}
          id={this.props.name}
          name={this.props.name}
          onChange={this._onChange.bind(this)}
          styleName="toggle-button-input"
          type="checkbox"
        />
        <label 
          htmlFor={this.props.name} 
          styleName="toggle-button-label"
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ToggleButton/ToggleButton.js